<template>
	<div class="data-service">
		<div class="title">数据服务</div>
		<div class="main">
			<el-row>
				<el-col :lg="3" :xl="3">
					<div class="hidden-md-and-down">&nbsp;</div>
				</el-col>
				<el-col :xs="24" :sm="24" :md="24" :lg="18" :xl="18">
					<div class="box">
						<div class="item" v-for="item in data" :key="item.id">
							<h6>{{item.content}}</h6>
							<p>{{item.title}}</p>
						</div>
					</div>
				</el-col>
				<el-col :lg="3" :xl="3">
					<div class="hidden-md-and-down">&nbsp;</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'DataService',
		props: ['data']
	}
</script>

<style>
  @media (min-width: 992px) {
    .data-service {
      background-image: url('../assets/images/dataservice-new.png');
      height: 439px;
    }

    .data-service .title {
      margin: 120px auto 0;
      width: 120px;
      height: 34px;
      font-size: 30px;
      font-weight: 500;
      color: #3A3F4D;
      line-height: 34px;
      display: inline-block;
    }

    .data-service .main {

    }

    .data-service .main .box {
      /* height: 369px; */
      padding-top: 60px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    .data-service .main .box .item {
      width: 360px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
    }

    .data-service .main .box .item h6 {
      height: 50px;
      font-size: 50px;
      font-weight: 500;
      color: #008FFF;
      line-height: 50px;
    }

    .data-service .main .box .item p {
      width: 104px;
      height: 37px;
      font-size: 26px;
      font-weight: 400;
      color: #3B3A40;
      line-height: 37px;
      margin-top: 18px;
      margin-bottom: 120px;
    }
  }


	@media (max-width:992px) {
    .data-service {
      background-image: url('../assets/images/dataservice-new.png');
      width: 100vw;
      padding-bottom: 12vw;
    }

    .data-service .title {
      margin: 6vw auto;
      font-size: 16px;
      font-weight: 500;
      color: #3A3F4D;
      line-height: 20px;
      display: inline-block;
    }

    .data-service .main {

    }

    .data-service .main .box {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    .data-service .main .box .item {
      width: 33vw;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
    }

    .data-service .main .box .item h6 {
      font-size: 18px;
      font-weight: 500;
      color: #008FFF;
      line-height: 24px;
    }

    .data-service .main .box .item p {
      font-size: 16px;
      font-weight: 400;
      color: #3B3A40;
      line-height: 22px;
      margin: 6vw auto;
    }
	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/DataService.vue